var generateComponentTheme = function generateComponentTheme(_ref) {
  var typography = _ref.typography,
    spacing = _ref.spacing;
  return {
    stemFontSize: typography.fontSizeMedium,
    rootMargin: spacing.xSmall,
    rootPadding: spacing.xxSmall,
    feedbackWrapperMargin: spacing.xxSmall,
    incorrectFeedbackWrapperPadding: spacing.small,
    userResponsePadding: spacing.xSmall
  };
};
export default generateComponentTheme;